<div class="space-y-2">
	@switch (field.type) {
		@case (FormFieldTypeEnum.TEXT) {
			<ng-container *ngTemplateOutlet="coreInputTemplate"></ng-container>
		}

		@case (FormFieldTypeEnum.EMAIL) {
			<ng-container *ngTemplateOutlet="coreInputTemplate"></ng-container>
		}

		@case (FormFieldTypeEnum.TEL) {
			<ng-container *ngTemplateOutlet="coreInputTemplate"></ng-container>
		}

		@case (FormFieldTypeEnum.PERCENTAGE) {
			<core-input-percent
				[id]="field.id"
				[formControl]="control"
				[label]="field.label"
			></core-input-percent>
		}

		@case (FormFieldTypeEnum.TEXT_AREA) {
			<textarea
				[id]="field.id"
				[formControl]="control"
				class="w-full text-sm p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
				rows="4"
				[placeholder]="field.placeholder"
			></textarea>
		}

		@case (FormFieldTypeEnum.DATE) {
			<core-datepicker
				[id]="field.id"
				[label]="field.label"
				[placeholder]="field.placeholder || ''"
				[invalid]="control.invalid && control.touched"
				[formControl]="control"
			></core-datepicker>
		}

		@case (FormFieldTypeEnum.SELECT) {
			<core-select
				[id]="field.id"
				[label]="field.label"
				[formControl]="control"
				[placeholder]="field.placeholder || 'Select an option'"
				[options]="selectOptions"
				[invalid]="control.invalid && control.touched"
			></core-select>
		}

		@case (FormFieldTypeEnum.RADIO_GROUP) {
			<core-radio-group
				[id]="field.id"
				[label]="field.label"
				[options]="field.options || []"
				[formControl]="control"
				[invalid]="control.invalid && control.touched"
			></core-radio-group>
		}

		@case (FormFieldTypeEnum.FILE) {
			<app-file-input-field
				[field]="field"
				[control]="control"
			></app-file-input-field>
		}
	}

	<ng-template #coreInputTemplate>
		<core-input
			[id]="field.id"
			[type]="field.type"
			[label]="field.label"
			[invalid]="control.invalid && control.touched"
			[formControl]="control"
		></core-input>
	</ng-template>
</div>

<!-- Info text -->
@if (field.info) {
	<div class="mt-2 p-3 bg-blue-50 border border-blue-200 rounded-md">
		<p class="text-sm text-blue-800">{{ field.info.text }}</p>
		<a
			*ngIf="field.info.link"
			[href]="field.info.link"
			target="_blank"
			class="text-sm text-blue-600 hover:text-blue-800 underline"
		>
			Learn more
		</a>
	</div>
}
